/**
* 左边菜单
*/
<template>
  <el-menu
		default-active="1"
		:collapse="collapsed"
		collapse-transition router
		:default-active="$route.path"
		unique-opened
		class="el-menu-vertical-demo"
	>
    <div class="logobox">
      <img class="logoimg" src="../assets/img/logo.png" alt="">
      HM能源管理云平台
   </div>
    <el-submenu v-for="menu in allmenu" :key="menu.id" :index="menu.name" >
      <template slot="title">
        <i class="iconfont fa" :class="menu.icon"></i>
        <span>{{menu.name}}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item v-for="chmenu in menu.menus" :index="'/'+chmenu.url" :key="chmenu.id">
          <i  class="iconfont icon-yuandian"></i>
          <span>{{chmenu.name}}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
import { menu } from '../api/userMG'
import store from '@/vuex/store'
export default {
  name: 'leftnav',
  data() {
    return {
      collapsed: false,

			perList:[],
      methodsList:[]
    }
  },
  computed:{
    allmenu(){
      return this.$store.state.menuList
    }
  },
  // 创建完毕状态(里面是操作)
  created() {

    this.$store.dispatch('getMenuList').then(res => {
      this.getPermission(res)
      this.$store.commit('setPerms', this.perList)

    })

    // 监听
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })
  },


	methods: {
		getPermission(list) {
			list.forEach(menu => {
				if(menu.permission != ""){
					this.perList.push(menu.permission)

				}


				if(menu.menus.length != 0){
					this.getPermission(menu.menus)

				}
			})
		},

	},
}
</script>
<style>
	.el-submenu .el-submenu__title i.iconfont{
		display: inline-block;

    line-height: 24px;
    margin-right: 10px;
    text-align: center;
    vertical-align: middle;
    width: 24px;
    height: 24px;
    color: #ffffff;
    border-radius: 2px;
		background-color: #5ab1ef;
		font-size:16px;
	}
  .el-menu-item.is-active{
    background: #c1ddfa;

  }


	.el-submenu:nth-of-type(2) .el-submenu__title i.iconfont{

		background-color: #d87a80;
	}
	.el-submenu:nth-of-type(3) .el-submenu__title i.iconfont{
		font-size:16px;
		background-color: #b6a2de;
	}
	.el-submenu:nth-of-type(4) .el-submenu__title i.iconfont{
		background-color: #ffb980;
	}
	.el-submenu:nth-of-type(5) .el-submenu__title i.iconfont{
		background-color: #2ec7c9;
	}
	.el-submenu:nth-of-type(6) .el-submenu__title i.iconfont{
		background-color: #dc69aa;
	}
  .el-submenu:nth-of-type(7) .el-submenu__title i.iconfont{
		background-color: #97b552;
	}
	.el-submenu:nth-of-type(8) .el-submenu__title i.iconfont{
    background-color: #ef1a06;
	}
  .el-submenu:nth-of-type(9) .el-submenu__title i.iconfont{
		background-color: #95706d;
	}



.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #1f2d3d !important;
}
.el-menu {
  border: none;
}
.logobox {
  height: 60px;
  line-height: 60px;
  color: #fff;
  font-size: 18px;
  padding-left: 56px;
  position: relative;
  background-color: #79bbff;
  overflow: hidden;
}
.logoimg {
  width: 40px;
  position: absolute;
  left: 10px;
  top: 14px;
}

</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue